import React from 'react';

const PageNotFound = () => (
	<div className='pageNotFound'>
		<h1>Page not found</h1>
	</div>
)

export default PageNotFound;


// WEBPACK FOOTER //
// ./src/components/PageNotFound.js